import * as React from "react";

const LabelIcon = ({
  className,
  color,
}: {
  className?: string;
  color?: string;
}) => (
  <svg className={className} width={512} height={512} viewBox="0 0 32 32">
    <path
      fill={color ?? "#fcd354"}
      d="M25 2v28a1 1 0 0 1-1.6.8L16 25.25 8.6 30.8A1 1 0 0 1 7 30V2a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1z"
    />
  </svg>
);
export default LabelIcon;
